import isPlainObject from 'lodash/isPlainObject'
import isArray from 'lodash/isArray'
import forEach from 'lodash/forEach'

export type FlattenObjectOptions = {
  array: boolean
}

/**
 * it will just flatten the object, with . as separator
 * It will return an array as is.
 * @param inputObject
 * @param options
 */
export const flattenObject = (inputObject: Record<any, any>, options?: FlattenObjectOptions): Record<string, any> => {
  const toReturn: Record<string, any> = {}

  for (const i in inputObject) {
    if (!Object.hasOwn(inputObject, i)) continue

    const currentObject = inputObject[i]

    if (isPlainObject(currentObject)) {
      const flatObject = flattenObject(currentObject, options)
      for (const x in flatObject) {
        if (!Object.hasOwn(flatObject, x)) continue

        toReturn[`${i}.${x}`] = flatObject[x]
      }
    } else if (isArray(currentObject)) {
      if (options?.array) {
        forEach(currentObject, (item, index) => {
          const flatObject = flattenObject(item, options)
          for (const x in flatObject) {
            if (!Object.hasOwn(flatObject, x)) continue

            toReturn[`${i}.${index}.${x}`] = flatObject[x]
          }
        })
      } else {
        toReturn[i] = inputObject[i]
      }
    } else {
      toReturn[i] = inputObject[i]
    }
  }
  return toReturn
}
